<template>
  <v-container class="px-0">
    <v-row>
      <v-col cols="1" class="text-md-right">
        <v-icon class="bg-red-darken-3" size="large">mdi-currency-usd</v-icon>
      </v-col>
      <v-col cols="11" class="">
        <p class="text-subtitle-1 pt-0">
          {{ $t('warehouse.forms.createWarehouseForm.messages.creatingAnAdditionalWarehouse') }}
          <span class="text-subtitle-1 text-red-darken-3 font-weight-bold">
            {{ $t('warehouse.forms.createWarehouseForm.messages.willResultInAdditionalCharges') }}
          </span>
          {{
            $t(
              'warehouse.forms.createWarehouseForm.messages.toYourAccountToTheExtentItExceedsTheOriginalNumberOfWarehousesPurchasedInYourOrderForm'
            )
          }}
        </p>

        <p class="text-subtitle-2">
          {{
            $t(
              'warehouse.forms.createWarehouseForm.messages.byCompletingTheProcessForCreatingAWarehouseYouAuthorizeLoadsmartToBillYourAccountAsPermittedByTheTermsOfYourOrderFormAndTheAssociatedSubscriptionAndProfessionalServicesAgreement'
            )
          }}
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <p class="mt-4">
          <v-checkbox :ripple="false" color="primary" v-model="acceptedTerms" hide-details>
            <template v-slot:label>
              <span class="text-subtitle-1">
                {{
                  $t('warehouse.forms.createWarehouseForm.messages.iHaveReadAndAcceptTheConditions')
                }}
              </span>
            </template>
          </v-checkbox>
        </p>

        <p class="mt-9 text-subtitle-2">
          {{
            $t(
              'warehouse.forms.createWarehouseForm.messages.ifYouNeedAnyHelpReachOutToOurSupportTeam'
            )
          }}
          <a
            target="_blank"
            href="https://community.loadsmart.com/hc/en-us/community/topics/14812876253715-OpenDock">
            {{ $t('warehouse.forms.createWarehouseForm.messages.throughThisLink') }}
          </a>
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'CreateWarehouseTerms',
  data() {
    return {
      acceptedTerms: false
    };
  },
  watch: {
    acceptedTerms() {
      this.$emit('update:model-value', this.acceptedTerms);
    }
  },
  methods: {
    onConfirm() {
      if (this.acceptedTerms) {
        this.$emit('confirm');
      } else {
        this.notify(
          this.$t('warehouse.forms.createWarehouseForm.messages.pleaseReadAndAcceptTheConditions'),
          'error'
        );
      }
    }
  }
};
</script>
